/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CalculateOvertimeForTimecardRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {CalculateOvertimeForTimecardResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const calculateOvertimeForTimecard = (request: CalculateOvertimeForTimecardRequest, options?: CashRequestOptions) => post<CalculateOvertimeForTimecardRequest, CalculateOvertimeForTimecardResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/CalculateOvertimeForTimecard", request, {...options, rejectOnError: true })